import { fetchApiDataV2, likeHandlerShorts, fetchApiData, updateApiData } from "../../utils/utils";
import axios from "axios";

export const getVerticalShowsList = async (appInfo, showIdentifier) => {
  const api = `verticalShows/${showIdentifier}`;
  return await fetchApiDataV2(appInfo, api);
};

export const likeHandler = async (id, liked, appInfo) => {
  const api = `like/video`;
  const data = {
    id,
    liked
  };
  return await likeHandlerShorts(api, data, appInfo);
};

// Record coin usage transaction with retry logic
export const recordCoinUsage = async (appInfo, videoId, consumptionType, maxRetries = 5) => {

  const attemptRequest = async (attempt = 1) => {
    try {      

    const location = {
      path: "verticalShows",
      values: {
        video_id: videoId,
        consumption_type: consumptionType,
      },
    };

    const response = await updateApiData(
      appInfo,
      "coins/record-usage",
      location
    );

      if (response?.data?.success) {
        console.log(`[CoinUsage] Successfully recorded usage for video ${videoId}:`, response.data.message);
        return response.data;
      } else {
        throw new Error(response?.data?.message || 'Failed to record coin usage');
      }
    } catch (error) {
      console.error(`[CoinUsage] Attempt ${attempt} failed for video ${videoId}:`, error.message);

      if (attempt < maxRetries) {
        // Exponential backoff: 1s, 2s, 4s, 8s, 16s
        const delay = Math.pow(2, attempt - 1) * 1000;
        console.log(`[CoinUsage] Retrying in ${delay}ms...`);
        
        await new Promise(resolve => setTimeout(resolve, delay));
        return attemptRequest(attempt + 1);
      } else {
        console.error(`[CoinUsage] All ${maxRetries} attempts failed for video ${videoId}. Final error:`, error.message);
        throw error;
      }
    }
  };

  return attemptRequest();
};

// Non-blocking wrapper for record coin usage
export const recordCoinUsageAsync = (appInfo, videoId, consumptionType = 'UNLOCK') => {
  // Run in background without blocking user experience
  recordCoinUsage(appInfo, videoId, consumptionType)
    .then(result => {
      console.log(`[CoinUsage] Background recording completed for video ${videoId}`);
    })
    .catch(error => {
      console.error(`[CoinUsage] Background recording failed for video ${videoId}:`, error);
      // Could add analytics/monitoring here if needed
    });
};
